// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DataCacheToolType } from '../DataCacheToolEnums';
import { DynProperty, PairColor } from '../../DynProperty';
import { Resources } from '@shared/localizations/Resources';
import { FillableDataCacheTool } from './FillableDataCacheTool';
import { ThemeManager } from '@front/controls/misc/ThemeManager';
export class PriceLabelDataCacheTool extends FillableDataCacheTool {
    constructor() {
        super();
        this.borderKey = 'property.borderColor';
        this.fontKey = 'property.Font';
        this.labelColorKey = 'property.LabelColor';
        this.ToolType = DataCacheToolType.PriceLabel;
        this.InitPoints(2);
    }
    ThemeChanged() {
        super.ThemeChanged();
        this.font = ThemeManager.Fonts.Font_12F_regular.copy();
    }
    MaxPointsCount() {
        return 1;
    }
    MinPointsCount() {
        return 1;
    }
    Properties() {
        const oldProps = super.Properties();
        const props = [];
        props.push(new DynProperty(this.borderKey, this.pen.Color, DynProperty.COLOR, DynProperty.VISUAL_GROUP));
        props.push(new DynProperty(this.fontKey, this.font.copy(), DynProperty.FONT, DynProperty.VISUAL_GROUP));
        props.push(new DynProperty(this.labelColorKey, new PairColor(this.FontColor, this.FillColor, Resources.getResource('property.text'), Resources.getResource('property.backgroundColor')), DynProperty.PAIR_COLOR, DynProperty.VISUAL_GROUP));
        const len = oldProps.length;
        for (let i = 0; i < len; i++) {
            const prop = oldProps[i];
            if (prop.group === DynProperty.NUMERICAL_PARAMETRS_GROUP ||
                prop.group === DynProperty.HIDDEN_GROUP ||
                prop.name === 'Stick to period' ||
                prop.name === 'IsBackground') {
                props.push(prop);
            }
        }
        return props;
    }
    callBack(properties) {
        super.callBack(properties);
        const borderProp = DynProperty.getPropertyByName(properties, this.borderKey);
        if (!isNullOrUndefined(borderProp))
            this.pen.Color = borderProp.value;
        const fontProp = DynProperty.getPropertyByName(properties, this.fontKey);
        if (!isNullOrUndefined(fontProp))
            this.font = fontProp.value;
        const pairColorProp = DynProperty.getPropertyByName(properties, this.labelColorKey);
        if (!isNullOrUndefined(pairColorProp)) {
            const pairColor = pairColorProp.value;
            this.FontColor = pairColor.Color1;
            this.FillColor = pairColor.Color2;
        }
    }
}
